const showMessage = (state) => state.alert
export default showMessage
